import { ConvertMillimetersToCentimeters, ConvertCentimetersToMillimeters } from '@/utils/converters';

function transformItem2Dto(item) {
  const dto = {
    ...item,
    linkDomainProductGroupFinishID: item.id,
    headingHeightInMm: ConvertCentimetersToMillimeters(item.headingHeight)
  };
  delete dto.id;
  delete dto.headingHeight;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.linkDomainProductGroupFinishID,
    headingHeight: ConvertMillimetersToCentimeters(dto.headingHeightInMm)
  };
  delete item.linkDomainProductGroupFinishID;
  delete item.headingHeightInMm;
  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };
